const React = require("react");
const T = React.PropTypes;

require("./Question.less");

const QuestionType = require("~/types/Question.js").PropType;

const questionChangeDispatchers = require("~/events/questionChange/questionChangeDispatchers.js")

const Checklist = require("../Checklist/Checklist.jsx");
const DropDown = require("../DropDown/DropDown.jsx");
const Freeform = require("../Freeform/Freeform.jsx");
const Table = require("../Table/Table.jsx");
const CauditList = require("../CauditList/CauditList.jsx");
const DateSelector = require("../DateSelector/DateSelector.jsx");

const QuestionStatus = require("../QuestionStatus/QuestionStatus.jsx");

const debounce = (fn, delayMs) => {
    var timer;

    return (...args) => {
        clearTimeout(timer);

        timer = setTimeout(() => {
            fn(...args);
        }, delayMs);
    };
};

const Question = React.createClass({
    propTypes: {
        SectionIDPath: T.arrayOf(T.string).isRequired,
        Question: QuestionType.isRequired,
        OnAnswerChange: T.func.isRequired,
        IsReadOnly: T.bool.isRequired
    },
    getInitialState() {
        return {
            QuestionIDPath: this.props.SectionIDPath.concat(this.props.Question.GUID)
        };
    },
    componentWillMount() {
        this.OnAnswerSelectionsChange = debounce(
            this.OnAnswerSelectionsChange,
            300);
    },
    render() {
        const showCommentField = this.props.Question.AnswerOptions[0].IncludeComment;

        const question = this.GetQuestion();

        const status = this.GetStatus();

        return (<div className="cs-Question">
                <fieldset disabled={this.props.IsReadOnly}>
                    {question}
                </fieldset>
            {status}
        </div>);
    },
    OnAnswerSelectionsChange(answerSelections, additionalComment, task) {
        questionChangeDispatchers.AnswersChanged(
            this.state.QuestionIDPath,
            answerSelections,
            additionalComment, 
            task);
    },
    GetQuestion() {
        switch (this.props.Question.QuestionType.BaseDisplayType) {
            case 1:
                return (<div>Checkbox goes here</div>);
            case 2:
                return (<div>Radiobuttons go here</div>);
            case 3:
                return (<DropDown Question={this.props.Question} OnAnswerChange={this.OnAnswerSelectionsChange } />);
            case 4:
                return (<div>Percent goes here</div>);
            case 5:
                return (<div>Numeric goes here</div>);
            case 6:
                return (<DateSelector Question={this.props.Question} OnAnswerChange={this.OnAnswerSelectionsChange} />);
            case 7:
                return (<Checklist Question={this.props.Question} OnAnswerChange={this.OnAnswerSelectionsChange } />);
            case 8:
                return (<Table Question={this.props.Question} OnAnswerChange={this.OnAnswerSelectionsChange }/>);
            case 101:
                return (<CauditList Question={this.props.Question} OnAnswerChange={this.OnAnswerSelectionsChange }/>);
            case 0:
            default:
                return (<Freeform Question={this.props.Question} OnAnswerChange={this.OnAnswerSelectionsChange } />);
        }

        return (<QuestionStatus Question={this.props.Question } />)
    },
    GetStatus() {
        if (!this.ShouldShowStatus()) {
            return null;
        }

        return (<QuestionStatus Question={this.props.Question } />)
    },
    ShouldShowStatus() {
        if (this.props.Question.UpdateError) return true;

        if (this.props.Question.ValidationStatus
            && !this.props.Question.ValidationStatus.IsValid) return true;

        return false;
    }
});

module.exports = Question;


// WEBPACK FOOTER //
// ./src/components/Question/Question.jsx